import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';
import { RENOLOG_ADMIN_LOCAL_API_REQUESTS } from './constants';

export const updateAdminRenologPricing = async (pricingData) => {
    const apiPath = `legacy_admin/renolog/pricing`;

    const signedRequest = await createSignedPatchRequest({
        apiPath,
        body: pricingData,
        isLocalApiRequest: RENOLOG_ADMIN_LOCAL_API_REQUESTS,
    });

    const response = await axios(signedRequest);
    return response.data;
};
